import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { VirtualizedList } from '@/components/core/InfiniteScrollList/VirtualizedList'
import { RecentOrdersProps } from './types'
import { MemberOrderListCard } from '@/components/list-cards/orders/MemberOrderListCard'

export function RecentOrders({ orders }: RecentOrdersProps) {
  const { t } = useTranslation()

  return (
    <Card className="flex-1 pb-0 border-none shadow-none px-0">
      <CardHeader className="px-0">
        <CardTitle>{t('customers.recentOrders')}</CardTitle>
      </CardHeader>

      <CardContent className="h-full px-0">
        <VirtualizedList
          items={orders}
          hasMore={false}
          renderItem={MemberOrderListCard}
          className="h-full"
        />
      </CardContent>
    </Card>
  )
} 